import React, {useState} from 'react';
import Button from '@material-ui/core/Button';
import MyRangeInput from '../../MyRangeInput'

export default function HelpMoreData(props){

      const [expand, setExpand] = useState(true)

      return (<span>
        {"You can see more data about each aspect be pressing on its title."}

        <div className="py-5 container-fluid prefernces-item prefernceNode">
          {/*<span className={"tollip"}>
            {nodeRepsentation.description}
          </span>*/}
          <div className="row">
            <div className="col-md-3 col-sm-12 px-0   node-title justify-content-center" align="center" style={{
                overflow: "hidden"
              }}>
                  <span  className="title" style={{fontSize:"25px", color:"blue"}}>
                    {"Reviews"}
                  </span>
            </div>
            <div className="col-md-9 col-sm-12 " style={{
                display: 'inline-block'
              }}>
              <span className="slider-icon none-sm" >
                <i class="fas fa-users" aria-hidden="true"></i>
              </span>
              <MyRangeInput label={""} value={5} color={"lightblue"} onChange={()=>{}} />
            </div>
          </div>
        </div>
      </span>);
}
